import db from "@/application/db";

const state = {
    showNotes: true,
    showNumbers: true,
    tabItemCount:6,
    articleTemplateBackground: "transparent",
    theme: "light",
    showPreviewTemplates: true,
};

const getters = {};

const actions = {
    async toggleNotes({ commit, state }) {
        commit('toggleNotes');
        await saveToIndexedDB('showNotes', state.showNotes);
    },
    async toggleNumbers({ commit, state }) {
        commit('toggleNumbers');
        await saveToIndexedDB('showNumbers', state.showNumbers);
    },
    async setTabItemCount({ commit, state } , value) {
        commit('setTabItemCount', value);
        await saveToIndexedDB('tabItemCount', state.tabItemCount);
    },
    async setArticleTemplateBackground({ commit, state } , value) {
        commit('setArticleTemplateBackground', value);
        await saveToIndexedDB('articleTemplateBackground', state.articleTemplateBackground);
    },
    async setTheme({ commit, state } , value) {
        commit('setTheme', value);
        await saveToIndexedDB('theme', state.theme);
    }
};

const mutations = {
    toggleNotes(state) {
        state.showNotes = !state.showNotes;
    },
    toggleNumbers(state) {
        state.showNumbers = !state.showNumbers;
    },
    setTabItemCount(state, value) {
        state.tabItemCount = value;
    },
    setArticleTemplateBackground(state, value) {
        state.articleTemplateBackground = value;
    },
    setTheme(state, value) {
        state.theme = value;
    }
};

const saveToIndexedDB = async (key, value) => {
    await db.transaction('rw', db.localSettings, async () => {
        const existingField = await db.localSettings.where('key').equals(key).first();
        if (!existingField) {
            await db.localSettings.add({ key, value });
        } else {
            await db.localSettings.update(existingField.id, { value });
        }
    }).catch(err => {
        console.error(err.stack || err);
    });
};

const loadState = async () => {
    const showNotes = await db.localSettings.where('key').equals('showNotes').first();
    const showNumbers = await db.localSettings.where('key').equals('showNumbers').first();
    const tabItemCount = await db.localSettings.where('key').equals('tabItemCount').first();
    const articleTemplateBackground = await db.localSettings.where('key').equals('articleTemplateBackground').first();
    const theme = await db.localSettings.where('key').equals('theme').first();
    state.showNotes = showNotes ? showNotes.value : true;
    state.showNumbers = showNumbers ? showNumbers.value : true;
    state.tabItemCount = tabItemCount ? tabItemCount.value : 6;
    state.articleTemplateBackground = articleTemplateBackground ? articleTemplateBackground.value : "transparent";
    state.theme = theme ? theme.value : "default";
};

await loadState();

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};